import {toast} from "react-toastify";
import {toastOptions} from "../../constants/WebPageConstants";
import React from "react";

export function toastMessageForSuccess(reportStatus, reportId, reportType) {
    toast.success(<>
        <p className="text-medium">{reportStatus
            ? "Report Saved Successfully"
            : "Report Submitted Successfully"
        }</p>
        <p className="text-small">{reportType + " id allotted. This page will be closing soon"}</p>
    </>, toastOptions);
}

export function throwErrorToast(e) {
    const code = e?.response?.data?.code;
    const message = e?.response?.data?.message;

    if (code === "NOMINATION_NOT_ALLOWED") {
        const typeLabel = e?.response?.data?.nominationType || "the selected nomination type";
        toast.error(<>
            <p className="text-medium">Nomination Window Closed</p>
            <p className="text-small">
                Submissions for <strong>{typeLabel}</strong> are not currently open.
                You can <strong>Save as Draft</strong> and submit once the window reopens.
            </p>
        </>, toastOptions);
        return;
    }

    toast.error(<>
        <p className="text-medium">{null != code ? code.replaceAll("_", " ") : "Internal Server Error"}</p>
        <p className="text-small">{null != message ? message : "Please contact IT Team to report and resolve the error. Issue Timestamp : " + new Date().toLocaleString()}</p>
    </>, toastOptions)
}
